import { Avatar, Button } from "@mui/material";
import { Card, CardContent } from "@mui/material";
import { useNavigate } from "react-router-dom";

export function FeaturedStories({ mainpost, filteredBlogs }) {
  const navigate = useNavigate();

  const handleViewBlog = (id, data) => {
    navigate(`/blog/${id}`, {
      replace: true,
      state: { data },
    });
  };

  return (
    <section className="container mx-auto px-4 py-8">
      <div className="grid md:grid-cols-2 gap-6">
        {/* Main Post */}
        <Button onClick={() => handleViewBlog(mainpost._id, mainpost)}>
          <Card
            className="relative overflow-hidden"
            style={{ width: "100%", maxWidth: "800px", height: "500px" }}
          >
            <div className="relative w-full h-full">
              <img
                src={mainpost.image}
                alt="Featured Story"
                className="object-cover w-full h-full"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
              <div className="absolute bottom-0 p-6 text-left text-white">
                <span className="bg-red-500 text-white px-2 py-1 text-xs rounded mb-4 inline-block">
                  1
                </span>
                <h2 className="text-2xl font-bold mb-4">{mainpost.title}</h2>
                <div className="flex items-center space-x-4">
                  <Avatar className="h-8 w-8" />
                  <div>
                    <p className="text-sm font-medium">{mainpost.author}</p>
                    <p className="text-xs opacity-80">{mainpost.date}</p>
                  </div>
                </div>
              </div>
            </div>
          </Card>
        </Button>

        {/* Secondary Posts */}
        <div className="grid gap-6">
          {filteredBlogs.map((post, i) => (
            <Button key={i} onClick={() => handleViewBlog(post._id, post)}>
              <Card
                className="relative overflow-hidden"
                style={{ width: "100%", maxWidth: "600px", height: "150px" }}
              >
                <div className="relative w-full h-full">
                  <img
                    src={post.image}
                    alt={`Story ${i + 1}`}
                    className="object-cover w-full h-full"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                  <div className="absolute bottom-0 p-4 text-white text-left">
                    <span className="bg-blue-500 text-white px-2 py-1 text-xs rounded mb-2 inline-block">
                      {i + 2}
                    </span>
                    <h3 className="text-lg font-bold line-clamp-1">
                      {post.title}
                    </h3>
                  </div>
                </div>
              </Card>
            </Button>
          ))}
        </div>
      </div>
    </section>
  );
}
